import { render, staticRenderFns } from "./oldstuffcontent.vue?vue&type=template&id=33dc0348"
import script from "./oldstuffcontent.vue?vue&type=script&lang=js"
export * from "./oldstuffcontent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports